import {useLocation, useNavigate} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import {Button, Collapse, Empty, NavBar, Toast} from "antd-mobile";
import {userOrderList} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const AzamPayOrders = () => {
    const {state} = useLocation();
    const mobile = state?.mobile || '';
    const navigate = useNavigate()
    const [list, setList] = useState<any[]>([]);

    const _getListData = useCallback(() => {
        Toast.show({icon: 'loading', content: 'Loading...', duration: 0})
        userOrderList(mobile).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                setList(res.data || []);
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }, [mobile])

    useEffect(() => {
        _getListData();
    }, [_getListData])

    const back = () => {
        navigate(-1);
    };

    const repayBtnDidClick = (item: any, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        navigate('/azampay/pay', {state: {orderNo: item.orderNo, mobile}})
    }

    const _getOrderStatusDesc = (status: number) => {
        if (status === 3) {
            return 'Overdue';
        }
        return '';
    }

    const _renderItemUI = (title: string, data: any) => {
        return <div style={{padding: '7px 0', display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontSize: 15}}>{title}</span>
            <span style={{fontSize: 15}}>{data}</span>
        </div>
    }

    const _renderInstallmentPlanItemUI = (item: any, index: number) => {
        return <div key={index} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>{item.installmentNumber}</span>
            <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>{item.dueDate}</span>
            <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>{item.paidOff === 2 ? 'Repaid' : item.repaymentAmount}</span>
        </div>
    }

    const _renderRepaymentPlan = (item: any[]) => {
        return <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>Periods</span>
                <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>Due Date</span>
                <span style={{fontSize: 12, flex: 1, textAlign: "center"}}>Amount</span>
            </div>
            {Array.isArray(item) && item.length ? item.map((i, index) => {
                return _renderInstallmentPlanItemUI(i, index)
            }) : <Empty description='No Data'/>}
        </div>
    }

    const _renderListUI = () => {
        if (list.length) {
            return <div>
                {list.map((item, index) => {
                    return <div key={index} style={{backgroundColor: '#FFF', margin: '10px', borderRadius: '8px', padding: '10px 15px'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', padding: '14px 0'}}>
                            <span style={{fontSize: 16, fontWeight: "400"}}>OrderNo: {item.orderNo}</span>
                            <span style={{fontSize: 16, fontWeight: "bold", color: "red"}}>{_getOrderStatusDesc(item.orderStatus)}</span>
                        </div>
                        <div style={{backgroundColor: '#EFEFEF', width: '100%', height: 1}}/>
                        {_renderItemUI('Product', item.model)}
                        {_renderItemUI('Memory', item.memorySize)}
                        {_renderItemUI('Color', item.color)}
                        {_renderItemUI('Contract Date', item.contractDate)}
                        <div style={{marginTop: 20}}>
                            <Collapse defaultActiveKey={['0']}>
                                <Collapse.Panel key='1' title='Repayment Plan'>
                                    {_renderRepaymentPlan(item.installmentPlanList)}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                        <div style={{padding: '15px 0'}}>
                            <Button onClick={(e) => repayBtnDidClick(item, e)} color='primary' style={{width: '100%'}}>Make Repayment</Button>
                        </div>
                    </div>
                })}
            </div>
        }
        return <Empty description='No Data'/>
    }

    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA', minHeight: '100vh'}}>
        <NavBar onBack={back} style={{backgroundColor: '#FFF'}}>My Orders</NavBar>
        {_renderListUI()}
    </div>
}
export default AzamPayOrders;